// extracted by mini-css-extract-plugin
export default {"cell":"TariffCell_cell__SiOnz"};